import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { 
	getRegisteredAnimalsChart
} from "../../../../redux/dashboard/dashboardState";
import CardItem from "components/card/CardItem";
import LineChart from "components/charts/LineChart";
import { MdBarChart } from "react-icons/md";
import ModalSearchFilter from "components/search/ModalSearchFilter";

const RegisteredAnimalsChart = ({getChartData, graphData, requesting, success, error, filters, ...props}) => {
  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);

  useEffect(() => {
      //getChartData(filters);
  }, [getChartData]);

  const isLoading = requesting && !success;
  const hasError = error && !requesting;

  const applyFilter = (filters) => {
    closeModal();
    getChartData(filters);
  }

  const resetFilter = () => {
    closeModal();
    getChartData(null);
  }
  
  return (
    <CardItem extra="pb-7 p-[10px]"
      headerClass="frosted-glass p-2 rounded-[20px]"
      icon={<MdBarChart className="h-6 w-6 text-theme-500 dark:text-theme-400"/>}
      title={"Registered Animals"}
      cardMenu={
        <button 
          onClick={openModal}
          className="linear rounded-[20px] bg-lightPrimary px-4 py-2 text-base font-medium text-theme-700 transition duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20">
        Filter
        </button>
      }
    >

      <div className="h-[340px] w-full pt-4 pb-0">
      {isLoading ? (
          <p className="text-gray-500 text-sm">Loading chart...</p>
        ) : hasError ? (
          <p className="text-red-500 text-sm">Failed to load chart data.</p>
        ) : (
          <LineChart
            series={graphData.series}
            options={graphData.options}
          />
        )}
      </div>
      <ModalSearchFilter 
        className="form-column-2" 
        isModalVisible={isModalVisible}
        closeModal={closeModal}
        filterHandler={applyFilter}
        resetHandler={resetFilter}
        title="Apply Filters"
        withDateRange={false}
        />
      
    </CardItem>
  );
};

const mapStateToProps = (state) => ({
    requesting: state.dashboard.registeredAnimalsChart?.requesting,
    success: state.dashboard.registeredAnimalsChart?.succcess,
    error: state.dashboard.registeredAnimalsChart?.error,
    graphData: state.dashboard.registeredAnimalsChart?.chartData,
    filters: state.dashboard.registeredAnimalsChart?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  getChartData: (filters) => dispatch(getRegisteredAnimalsChart(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisteredAnimalsChart);
